import { render } from "./BackofficeNavbar.vue?vue&type=template&id=030abe1e"
import script from "./BackofficeNavbar.vue?vue&type=script&lang=js"
export * from "./BackofficeNavbar.vue?vue&type=script&lang=js"

import "./BackofficeNavbar.vue?vue&type=style&index=0&id=030abe1e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__